<template>
	<div class="super_category_list_container"
	:class="$mq">
		
		<div class="super_category_list_header">
			
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12">
						Browse by category
					</div>
				</div>
			</div>

		</div>

		<div
		v-if="super_category_list.length == 0 || master_contest_list.length == 0"
		class="loading_indicator"
		>Loading contests...</div>
		
		<super-category-single
		v-for="(supercat, index) in super_category_list"
		:key="`supercat_`+index"
		:contests="master_contest_list"
		:supercat_data="supercat"
		:list_type="list_type"
		></super-category-single>

	</div>
</template>

<script>
import SuperCategorySingle from '@/features/category/super_category_single.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);

export default {
	name: 'SuperCategoryList',
	props: [
		'list_type'
	],
	data () {
		return {
			
		}
	},
	mounted() {
		let vm = this;
		vm.$root.store.categories.refresh_super_category_list(this.instanceid);
	},
	computed: {
		instanceid: function() {
			return this.$root.store.instances.state.instanceid;
		},
		super_category_list: function() {
			return this.$root.store.categories.get_current_super_category_list();
		},
		master_contest_list: function() {
			return this.$root.store.contests.get_current_master_contest_list();
		}
	},
	watch: {
		
	},
	components: {
		SuperCategorySingle
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.super_category_list_container {

	&.desktop, &.laptop {
		width: 40%;
		margin: 0 auto;
		border: solid 1px #ccc;
	}

	.super_category_list_header {
		color: #FFF;
		font-size: 1.6rem;
		border-bottom: solid 1px #ccc;
		text-align: center;

		.row {
			background: #1A7D7D;
			padding: 0.6em 0;
		}

	}

	.loading_indicator {
		width: 100%;
		text-align: center;
		font-weight: bold;
		margin: 1em 0;
		padding: 1em;
		background: #DDD;
	}

}

</style>



// WEBPACK FOOTER //
// src/features/category/super_category_contest_list.vue